import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const addCustomPanelMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Add Panel',
		onClick: ({ context, controller }): void => {
			controller.publishRequestedAction('add_custom_panel', context.id);
		}
	};
};
